<template>
  <OpDialog
    class="opple-control-area-awake-dialog"
    :visible="visible"
    :is-show-btn="false"
    @onClose="onClose"
  >
    <div class="opple-control-area-awake">
      <div class="opple-control-area-awake_lt">
        <img :src="displayImage">
      </div>
      <div class="opple-control-area-awake_gt">
        <div class="opple-control-area-awake_info">
          <p>{{ displayTip }}</p>
        </div>
        <div class="opple-control-area-awake_btnList">
          <div
            :class="{ disabled: isLoadingConfiguration }"
            class="opple-control-area-awake_btn blue"
            @click="onConfiguration"
          >
            {{ $t('ifttt.aWakened') }}
          </div>
        </div>
      </div>
    </div>
  </OpDialog>
</template>

<script>
import OpDialog from '@/components/common/OpDialog'

const KNOB_AWAKE_IMAGE = 'https://appresource.opple.com/media/upgrade/2026/03/30/20260330113819_4.png'

export default {
  components: {
    OpDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isLoadingConfiguration: {
      type: Boolean,
      default: false,
    },
    imageUrl: {
      type: String,
      default: '',
    },
    tipText: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayImage() {
      return this.imageUrl || KNOB_AWAKE_IMAGE
    },
    displayTip() {
      return this.tipText || this.$t('ifttt.wakePro')
    },
  },
  methods: {
    onClose() {
      this.$emit('onClose')
    },
    onConfiguration() {
      if (this.isLoadingConfiguration) return
      this.$emit('onOk')
    },
  },
}
</script>

<style lang="scss">
.opple-control-area-awake-dialog {
  width: 600px;
  min-height: 206px;
  background: #f2f3f5;

  .opDialog_body {
    min-height: 206px;
    max-height: 206px;
    background: #f2f3f5;
  }
}

.opple-control-area-awake {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 47px;
  background: #f2f3f5;

  &_lt {
    img {
      width: 100px;
      height: 100px;
    }
  }

  &_info {
    margin: 60px 0 40px;
    font-size: 17px;
  }

  &_btnList {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &_btn {
    min-width: 143px;
    height: 46px;
    border-radius: 8px;
    padding: 0 10px;
    white-space: nowrap;
    font-size: 16px;
    line-height: 46px;
    text-align: center;
    cursor: pointer;

    &.blue {
      background: #2145a4;
      color: #fff;

      &.disabled {
        background: #dddedf;
        color: #606060;
        cursor: not-allowed;
      }
    }
  }
}
</style>
